// extracted by mini-css-extract-plugin
export default {"cookie-consent":"MainRouter_cookie-consent__+yuJb","consent-message":"MainRouter_consent-message__8WXW3"};